import type {ReactElement} from 'react';
import React, {useEffect} from 'react';
import type {ColorStorage} from '@Components/color-picker-v2';
import {getFillTypeFromColorFillType, getRGBAArrayFromColorStorage} from '@Utils/color.util';
import type {ColorFillPropertyType} from '@Components/color-fill';
import {BaseFillColorPanel} from '@Components/poster-editor/components/poster-editing-side-panel/components/base-fill-color-panel';
import {useSingleActivePosterItemId} from '@Hooks/poster-editor/useSingleActivePosterItemId';
import {useGetKeyFromFillOfActiveItem} from '@Hooks/poster-editor/useGetKeyFromFillOfActiveItem';

interface VectorFillColorPanelProps {
  closePanel?(): void;
}

export function VectorFillColorPanel({closePanel = (): void => {}}: VectorFillColorPanelProps): ReactElement {
  const activeItemId = useSingleActivePosterItemId() ?? '';
  const activeItem = activeItemId ? window.posterEditor?.whiteboard?.getItemForId(activeItemId) : undefined;
  const fillType = useGetKeyFromFillOfActiveItem('fillType');
  const fillColor = useGetKeyFromFillOfActiveItem('fillColor');

  if (!activeItem || (activeItem && !('fill' in activeItem)) || !fillColor || fillType === undefined) {
    throw new Error(`Item doesn't have fill property`);
  }

  useEffect((): void => {
    if (!activeItem.fill.hasFill()) {
      closePanel();
    }
  }, [fillType]);

  const onChangeColorEnded = (updatedColor: ColorStorage[]): void => {
    activeItem.updateFillColor(getRGBAArrayFromColorStorage(updatedColor), true);
  };

  const onChangeColorFillColor = (updatedColor: ColorStorage[]): void => {
    activeItem.updateFillColor(getRGBAArrayFromColorStorage(updatedColor), false);
  };

  const onChangeType = (newType: ColorFillPropertyType): void => {
    void activeItem.updateFromObject({
      fill: {
        fillType: getFillTypeFromColorFillType(newType),
        fillColor: activeItem.fill.getColorForNewType(getFillTypeFromColorFillType(newType)),
      },
    });
  };

  return <BaseFillColorPanel colorObject={{fillType, fillColor}} onChangeColor={onChangeColorFillColor} onChangeColorEnded={onChangeColorEnded} onChangeType={onChangeType} />;
}
